export default __webpack_public_path__ + "static/abmg-building-with-logo-default-bd49888861cbd90fce70e54bbce57af6.jpg";